import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { DashboardShell } from "../../components/shared/DashboardShell";
import { adminNav } from "../../components/shared/navConfig";
import DirectWorkThread from "../../components/shared/DirectWorkThread";

export default function AdminDirectWorkThread() {
  const { id } = useParams();
  return (
    <DashboardShell nav={adminNav} title="Direct workroom" subtitle="Admin ↔ student direct conversation.">
      <DirectWorkThread dwId={id} backTo="/admin/direct-work"/>
    </DashboardShell>
  );
}
